import { useLocation, Link, matchPath, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import routeConfig from "../../routes/Config";
import { apiClient } from "../api/ApiClient";
import BranchModal from "../../pages/dashboard/BranchModal";
import { menuItems } from './Sidebar';

function Header() {
    const location = useLocation();
    const navigate = useNavigate();
    const activeRoute = routeConfig.find(route => matchPath({ path: route.path, end: false }, location.pathname));

    const [userData, setUserData] = useState({
        username: '',
        firstName: '',
        lastName: '',
        company: ''
    });
    const [counts, setCounts] = useState({ notifCount: 0, ticketCount: 0 });
    const [notifications, setNotifications] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [showBranchModal, setShowBranchModal] = useState(false);
    const [activeTab, setActiveTab] = useState('v-pills-general');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const storedData = localStorage.getItem('user_data');
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                setUserData({
                    username: parsed.username || '',
                    firstName: parsed.first_name || parsed.firstName || '',
                    lastName: parsed.last_name || parsed.lastName || '',
                    company: parsed.company || parsed.company_name || ''
                });
            } catch (e) {
                console.error('Error parsing user data:', e);
            }
        }
    }, []);

    useEffect(() => {
        const fetchNotificationData = async () => {
            try {
                const countData = await apiClient('/internal-network/api/notification-option/');
                setCounts({
                    notifCount: countData.notifCount || 0,
                    ticketCount: countData.ticketCount || 0
                });

                if (countData.notifCount > 0) {
                    /* TEMP-HIDDEN: صندوق پستی — restore when needed
                    const notifs = await apiClient('/internal-network/api/notification/?type=received&filter=unread');
                    setNotifications(notifs);
                    */
                    setNotifications([]);
                } else {
                    setNotifications([]);
                }

                if (countData.ticketCount > 0) {
                    const ticketList = await apiClient('/internal-network/api/ticket/');
                    setTickets(ticketList);
                } else {
                    setTickets([]);
                }
            } catch (error) {
                console.error("Error fetching notifications:", error);
            }
        };

        fetchNotificationData();
        const interval = setInterval(fetchNotificationData, 5000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!window.bootstrap) return;
        document.querySelectorAll('[data-bs-toggle="dropdown"][aria-expanded="true"]').forEach((el) => {
            const instance = window.bootstrap.Dropdown.getInstance(el);
            if (instance) instance.hide();
        });
    }, [location.pathname]);

    const handleLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user_data');
        navigate('/login/');
    };

    const displayName = userData.firstName && userData.lastName
        ? `${userData.firstName} ${userData.lastName}`
        : userData.username || 'کاربر';

    const avatarLetter = userData.company ? userData.company.charAt(0).toUpperCase() : 'ک';

    const toggleMobileMenu = (e) => {
        e.preventDefault();
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (!isMobileMenuOpen) {
            document.documentElement.classList.add('nxl-lavel-mega-menu-open');
        } else {
            document.documentElement.classList.remove('nxl-lavel-mega-menu-open');
        }
    };

    const closeMobileMenu = (e) => {
        setIsMobileMenuOpen(false);
        document.documentElement.classList.remove('nxl-lavel-mega-menu-open');
    };

    const handleMobileLinkClick = (path) => {
        closeMobileMenu();
        navigate(path);
    };

    const renderMegaMenuContent = () => {
        return (
            <div className="dropdown nxl-h-item nxl-mega-menu">
                <div className="dropdown-menu nxl-h-dropdown show" id="mega-menu-dropdown">
                    <div className="d-lg-flex align-items-start">
                        <div className="nav flex-column nxl-mega-menu-tabs" role="tablist" aria-orientation="vertical">
                            {menuItems.map((item, index) => (
                                <button
                                    key={index}
                                    className={`nav-link ${item.children && item.children.length > 3 ? 'nxl-mega-menu-lg' : 'nxl-mega-menu-md'} ${activeTab === `v-pills-${index}` ? 'active' : ''}`}
                                    data-bs-toggle="pill"
                                    data-bs-target={`#v-pills-${index}`}
                                    type="button"
                                    role="tab"
                                    onClick={() => setActiveTab(`v-pills-${index}`)}
                                >
                                    <span className="menu-icon">
                                        <i className={item.icon}></i>
                                    </span>
                                    <span className="menu-title">{item.name}</span>
                                    <span className="menu-arrow">
                                        <i className="feather-chevron-down"></i>
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className="tab-content nxl-mega-menu-tabs-content">

                            {menuItems.map((item, index) => (
                                <div key={index} className={`tab-pane fade ${activeTab === `v-pills-${index}` ? 'show active' : ''}`} id={`v-pills-${index}`} role="tabpanel">
                                    {item.isSingle ? (
                                        <div className="row g-4">
                                            <div className="col-lg-6">
                                                <h6 className="dropdown-item-title">{item.name}</h6>
                                                <button className="dropdown-item" onClick={() => handleMobileLinkClick(item.path)}>
                                                    <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                    <span>{item.name}</span>
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row g-4">
                                            <div className="col-lg-6">
                                                <h6 className="dropdown-item-title">{item.name}</h6>
                                                {item.children && item.children.map((child, childIndex) => (
                                                    <button key={childIndex} className="dropdown-item" onClick={() => handleMobileLinkClick(child.path)}>
                                                        <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                        <span>{child.name}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <header className="nxl-header">
            <div className="header-wrapper">
                <style>{`
                    @media (min-width: 992px) and (max-width: 1199.98px) {
                        .nxl-navigation {
                            display: block !important;
                            visibility: visible !important;
                            transform: none !important;
                            right: 0 !important;
                            // right: auto !important;
                            z-index: 1020 !important;
                        }
                    }
                `}</style>
                <div className="header-left d-flex align-items-center gap-4">
                    <a href="#" onClick={toggleMobileMenu} className="nxl-head-mobile-toggler d-lg-none" id="mobile-collapse">
                        <i className="feather-align-right"></i>
                    </a>
                    <div className="nxl-navigation-toggle d-none d-lg-flex">
                        <a href="#" onClick={(e) => e.preventDefault()} id="menu-mini-button">
                            <i className="feather-align-right"></i>
                        </a>
                        <a href="#" onClick={(e) => e.preventDefault()} id="menu-expend-button"
                            style={{ display: "none" }}>
                            <i className="feather-arrow-left"></i>
                        </a>
                    </div>
                    <div className={`nxl-drp-link nxl-lavel-mega-menu d-lg-none ${isMobileMenuOpen ? 'd-block' : 'd-none'}`}>
                        <div className="nxl-lavel-mega-menu-toggle d-flex d-lg-none">
                            <a href="#" onClick={closeMobileMenu} id="nxl-lavel-mega-menu-hide">
                                <i className="feather-arrow-right me-2"></i>
                                <span>بستن</span>
                            </a>
                        </div>
                        <div className="nxl-lavel-mega-menu-wrapper d-flex gap-3">
                            {renderMegaMenuContent()}
                        </div>
                    </div>
                </div>
                <div className="header-right ms-auto">
                    <div className="d-flex align-items-center">
                        <div className="dropdown nxl-h-item nxl-header-language d-none d-sm-flex">
                            <a href="#" onClick={(e) => e.preventDefault()}
                                className="nxl-head-link me-0 nxl-language-link">
                                <img src="/assets/vendors/img/flags/4x3/ir.svg" alt="" className="img-fluid wd-20" />
                            </a>
                        </div>
                        <div className="nxl-h-item dark-light-theme">
                            <a href="#" onClick={(e) => e.preventDefault()}
                                className="nxl-head-link me-0 dark-button">
                                <i className="feather-moon"></i>
                            </a>
                            <a href="#" onClick={(e) => e.preventDefault()}
                                className="nxl-head-link me-0 light-button"
                                style={{ display: "none" }}>
                                <i className="feather-sun"></i>
                            </a>
                        </div>
                        <div className="dropdown nxl-h-item">
                            <a href="#" onClick={(e) => e.preventDefault()} className="nxl-head-link me-0"
                                data-bs-toggle="dropdown"
                                role="button"
                                data-bs-auto-close="outside">
                                <i className="feather-mail"></i>
                                {counts.ticketCount > 0 && <span className="badge bg-success nxl-h-badge">{counts.ticketCount}</span>}
                            </a>
                            <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-notifications-menu">
                                <div className="d-flex justify-content-between align-items-center notifications-head">
                                    <h6 className="fw-bold text-dark mb-0">تیکت ها</h6>
                                    <span
                                        className="fs-11 text-success text-end ms-auto"
                                        data-bs-toggle="tooltip"
                                        data-bs-trigger="hover"
                                        data-bs-placement="bottom"
                                        data-bs-container="body"
                                        data-bs-title="نمایش تعداد تیکت‌های در انتظار پاسخ"
                                    >
                                        <i className="feather-mail"></i>
                                        <span className="ms-1">{counts.ticketCount} جدید</span>
                                    </span>
                                </div>
                                {counts.ticketCount > 0 ? (
                                    <div className="notifications-item-wrapper" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        {tickets.slice(0, counts.ticketCount).map((ticket) => (
                                            <div key={ticket.id} className="notifications-item">
                                                <div className="avatar-image rounded me-3 border d-flex align-items-center justify-content-center bg-primary text-white">
                                                    <i className="feather-mail"></i>
                                                </div>
                                                <div className="notifications-desc">
                                                    <Link to={`/ticket/chat/${ticket.id}/`} className="font-body text-truncate-2-line">
                                                        <span className="fw-semibold text-dark">{ticket.title}</span>
                                                        <br />
                                                        <span className="text-muted fs-12">در انتظار پاسخ شما</span>
                                                    </Link>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="notifications-date text-muted border-bottom border-bottom-dashed">
                                                            {ticket.last_message_time}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column align-items-center justify-content-center p-4">
                                        <i className="feather-mail fs-1 mb-4 text-muted"></i>
                                        <p className="text-muted mb-3">هیچ تیکت جدیدی ندارید!</p>
                                        <Link to="/ticket/create/" className="btn btn-sm btn-primary">بازکردن یک تیکت</Link>
                                    </div>
                                )}
                                <div className="text-center notifications-footer d-flex justify-content-center gap-2">
                                    <Link to="/ticket/create/" className="fs-13 fw-semibold text-primary">ثبت تیکت</Link>
                                    <span className="text-muted">|</span>
                                    <Link to="/ticket/list/" className="fs-13 fw-semibold text-dark">همه تیکت ها</Link>
                                </div>
                            </div>
                        </div>
                        {/* TEMP-HIDDEN: صندوق پستی (اعلان‌ها) — restore when needed
                        <div className="dropdown nxl-h-item">
                            <a className="nxl-head-link me-3" data-bs-toggle="dropdown" href="index.html#"
                                role="button"
                                data-bs-auto-close="outside">
                                <i className="feather-bell"></i>
                                {counts.notifCount > 0 && (
                                    <span className="badge bg-danger nxl-h-badge">
                                        {counts.notifCount}
                                    </span>
                                )}
                            </a>
                            <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-notifications-menu">
                                <div
                                    className="d-flex justify-content-between align-items-center notifications-head">
                                    <h6 className="fw-bold text-dark mb-0">اعلان ها</h6>
                                </div>
                                <div className="notifications-item-wrapper" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    {notifications.map((notif) => (
                                        <div key={notif.id} className="notifications-item">
                                            <div className="avatar-image rounded me-3 border d-flex align-items-center justify-content-center bg-success text-white">
                                                <i className="feather-bell"></i>
                                            </div>
                                            <div className="notifications-desc">
                                                <Link to="/notifications/" className="font-body text-truncate-2-line">
                                                    <span className="fw-semibold text-dark">
                                                        {notif.company_name || notif.sender_username || "پیام سیستم"}
                                                    </span>
                                                    <br />
                                                    {notif.type === 'invoice_sent' ? 'یک فاکتور جدید دریافت کردید' : 'پیام جدید دریافت کردید'}
                                                </Link>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="notifications-date text-muted border-bottom border-bottom-dashed">
                                                        {notif.created_at}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="text-center notifications-footer">
                                    <Link to="/notifications/" className="fs-13 fw-semibold text-dark">تمام اعلان ها</Link>
                                </div>
                            </div>
                        </div>
                        */}
                        <div className="dropdown nxl-h-item">
                            <a href="#" onClick={(e) => e.preventDefault()} data-bs-toggle="dropdown" role="button"
                                data-bs-auto-close="outside">
                                <div className="user-avtar me-0 d-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                                    style={{ width: '36px', height: '36px', fontSize: '16px', fontWeight: 'bold', textTransform: 'capitalize' }}>
                                    {avatarLetter}
                                </div>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                                <div className="dropdown-header">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                                            style={{ width: '40px', height: '40px', fontSize: '18px', fontWeight: 'bold', minWidth: '40px', textTransform: 'capitalize' }}>
                                            {avatarLetter}
                                        </div>
                                        <div className="me-3 ms-3">
                                            <h6 className="text-dark mb-0" style={{ textTransform: 'capitalize' }}>{displayName} {userData.company && <span
                                                className="badge bg-soft-success text-success ms-1" style={{ textTransform: 'capitalize' }}>{userData.company}</span>}
                                            </h6>
                                            <span
                                                className="fs-12 fw-medium text-muted" style={{ textTransform: 'capitalize' }}>{userData.username || 'کاربر'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="dropdown">
                                    <a href="#" className="dropdown-item"
                                        data-bs-toggle="dropdown">
                                        <span className="hstack">
                                            <i className="feather-sliders me-2"></i>
                                            <span>تنظیمات حساب کاربری</span>
                                        </span>
                                        <i className="feather-chevron-right ms-auto me-0"></i>
                                    </a>
                                    <div className="dropdown-menu">
                                        <Link to="/change-password/" className="dropdown-item">
                                            <span className="hstack">
                                                <span>تغییر رمز عبور</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="dropdown">
                                    <a href="#" onClick={(e) => e.preventDefault()} className="dropdown-item"
                                        data-bs-toggle="dropdown">
                                        <span className="hstack">
                                            <i className="feather-package me-2"></i>
                                            <span>اشتراک ها</span>
                                        </span>
                                        <i className="feather-chevron-right ms-auto me-0"></i>
                                    </a>
                                    <div className="dropdown-menu">
                                        <Link to="/subscription/general/" className="dropdown-item">
                                            <span className="hstack">
                                                <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                <span>عمومی</span>
                                            </span>
                                        </Link>
                                        <Link to="/subscription/all/" className="dropdown-item">
                                            <span className="hstack">
                                                <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                <span>همه</span>
                                            </span>
                                        </Link>
                                        <Link to="/subscription/app/" className="dropdown-item">
                                            <span className="hstack">
                                                <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                <span>نرم افزار سامانه مودیان</span>
                                            </span>
                                        </Link>
                                        <div className="dropdown-divider"></div>
                                        <Link to="/applications/" className="dropdown-item">
                                            <span className="hstack">
                                                <i className="wd-5 ht-5 bg-gray-500 rounded-circle me-3"></i>
                                                <span>نرم افزار ها</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="dropdown-divider"></div>
                                <Link to="/profile/details/" className="dropdown-item">
                                    <i className="feather-user"></i>
                                    <span>جزئیات حساب کاربری</span>
                                </Link>
                                <Link to="/settings/" className="dropdown-item">
                                    <i className="feather-settings"></i>
                                    <span>تنظیمات</span>
                                </Link>
                                <div className="dropdown-divider"></div>
                                <a href="#" onClick={handleLogout} className="dropdown-item">
                                    <i className="feather-log-out"></i>
                                    <span>خروج</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BranchModal
                isVisible={showBranchModal}
                onClose={() => setShowBranchModal(false)}
                initialData={null}
            />
        </header>
    );
}

export default Header;